export enum TipoTopicoAula {
    APRESENTACAO = "APRESENTACAO",
    CONTEUDO = "CONTEUDO",
    FEEDBACK = "FEEDBACK"
}